'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var cx = _bind2.default.bind(_style2.default);

var SucceededMessage = function SucceededMessage(_ref) {
  var children = _ref.children;
  return _react2.default.createElement('div', {
    className: cx('xsui-messages__succeeded')
  }, children);
};

SucceededMessage.propTypes = {
  children: _propTypes2.default.any.isRequired
};
exports.default = SucceededMessage;